<div id="container">
    <app-menu activeElement="settings"></app-menu>
    <div class="page">
        <div id="inner">
            <div class="page-card">
                <h1> {{'screens.settings.title' | translate}}</h1>
                <section>
                    <h2 class="extra-space">{{'screens.settings.connections.title' | translate}}</h2>
                    <div>
                        <h3>{{ deviceIsPlug ? ('ionaSpecific.devices.plug2' | translate) : isBox2 ? ('ionaSpecific.devices.box2' | translate) : ('ionaSpecific.devices.box' | translate) }}</h3>
                        <div class="connection-container p-b-l p-t-s">
                            <div class="p-r-s">
                                <app-connection-indicator [value]="wifiConnectionQuality"
                                                          container_height="24px"
                                                          [disabled]="wifiConnected >= 0"
                                                          [config]="wifiConnectionConfig"
                                                          [ignoreValue]="lanConnected">
                                </app-connection-indicator>
                            </div>
                            <ng-container *ngIf="lanConnected else wifiConnection">
                                <div>{{'common.connected' | translate}}</div>
                            </ng-container>
                            <ng-template #wifiConnection>
                                <div>
                                    {{ wifiConnected < 0 ? ('screens.settings.connections.wifiConnected' | translate) : ('screens.settings.connections.wifiDisconnected' | translate) }}
                                </div>
                            </ng-template>
                        </div>

                        <h3>{{'screens.settings.meter.title' | translate}}</h3>
                        <div class="connection-container p-r-s p-b-l">
                            <div class="p-r-s">
                                <app-connection-indicator [value]="meterConnectionQuality"
                                                          [container_height]="'24px'"
                                                          [disabled]="meterStatus !== 'connected'"
                                                          [config]="meterConnectionConfig">
                                </app-connection-indicator>
                            </div>
                            <div>{{determineMeterStatusMessage()}}</div>
                        </div>

                        <ng-container *ngIf="pincode">
                            <h3>{{'screens.settings.pincode.title' | translate}}</h3>
                            <div class="p-r-s">
                                {{pincode}}
                            </div>
                        </ng-container>

                        <ng-container *ngIf="isEDGUser && userService.isEnviamUser() && pinEntryUnknownOrOptical">
                            <button class="iona-button orange m-t-l"
                                    [disabled]="currentBatteryState === 0"
                                    (click)="onPinEntryOpen()">
                                {{'screens.settings.pinEntry.button' | translate}}
                            </button>
                        </ng-container>

                        <ng-container *ngIf="isEDGUser">
                            <h3 class="m-t-l">{{'screens.settings.batteryStatus.title' | translate}}</h3>
                            <div class="p-t-s">
                                <app-battery-load [currentBatteryState]="currentBatteryState"
                                                  [isAvailable]="currentBatteryState >= 0">
                                </app-battery-load>
                            </div>

                            <button class="iona-button orange m-t-x"
                                    [disabled]="currentBatteryState === 0"
                                    (click)="onEnergySaverOpen()">
                                {{'screens.settings.energySaver.button' | translate}}
                            </button>
                        </ng-container>
                    </div>
                </section>

                <section>
                    <h2 class="extra-space">{{'screens.settings.onlineMode.title' | translate}}</h2>
                    <div class="iona-checkbox-wrap">
                        <label class="iona-checkbox" for="optin-checkbox">
                            <input #optInCb type="checkbox" name="checkbox" id="optin-checkbox"
                                   [checked]="config.optIn"
                                   (change)="setOptIn(optInCb.checked)">
                            {{'screens.settings.onlineMode.label' | translate}}
                        </label>
                        <p [innerHTML]="'ionaSpecific.settings.onlineMode.description' | translate: {
                            device: (deviceIsPlug ? ('ionaSpecific.devices.plug3' | translate) : (isBox2 ? ('ionaSpecific.devices.box4' | translate) : ('ionaSpecific.devices.box3' | translate))),
                            privacyUrl: 'https://www.enviam.de/Media/docs/default-source/iona-app/dsi-iona-120522.pdf',
                            transparencyUrl: 'https://www.eon.de/content/dam/eon/eon-de-zwei/documents/Privatkunden/smart-control/eon-smart-control-transparenzerklärung.pdf'
                        }">
                        </p>
                    </div>
                    <h2 class="extra-space">{{ 'screens.settings.anonymousDataProcessing.title' | translate }}</h2>
                    <div class="iona-checkbox-wrap">
                        <label class="iona-checkbox" for="hhc-optout-checkbox">
                            <input #hhcOptOutCb type="checkbox" name="checkbox" id="hhc-optout-checkbox"
                                   [checked]="config.householdComparisonOptOut"
                                   (change)="setHouseholdComparisonOptOut(hhcOptOutCb.checked)">
                            {{ 'screens.settings.anonymousDataProcessing.label' | translate }}
                        </label>
                        <p>
                            {{ 'screens.settings.anonymousDataProcessing.description' | translate }}
                        </p>
                    </div>
                </section>
                <button class="iona-button orange" (click)="saveSettings()">
                    {{ 'screens.settings.saveButton' | translate }}
                </button>
            </div>
        </div>
    </div>
</div>
